import moment from 'moment'

import { withFormsy } from 'formsy-react'
import DateTimePicker from 'shared/components/TimePicker/DateTimePicker'

const FormsyDateTimePicker = ({
    errorMessage,
    setValue,
    onChange,
    name,
    value,
    required,
    validationError,
    showError,
    ...dateTimePickerProps
}) => {
    const changeValue = momentDate => {
        const isoString = momentDate ? momentDate.toISOString() : ''

        setValue(isoString)

        // Create synthetic event for onChange handler to update formValues
        const syntheticEvent = {
            target: {
                name,
                value: isoString,
            },
        }

        if (onChange) {
            onChange(syntheticEvent)
        }
    }

    // Convert ISO string value to moment object for DateTimePicker
    const convertToMoment = value => (value ? moment(value) : undefined)

    return (
        <div className="form-group">
            <DateTimePicker {...dateTimePickerProps} onChange={changeValue} value={convertToMoment(value)} />
            {showError && errorMessage && <span className="text-small text-red">{errorMessage}</span>}
        </div>
    )
}

export default withFormsy(FormsyDateTimePicker)
